<template>
	<div style="width: 90%;">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商户名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<!-- <el-form-item label="商品编号" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item> -->
					<el-form-item label="定存类别">
						<el-select v-model="searchInfo.fixedType" class="big" placeholder="请选择"
							@change="getStoreName">
							<el-option v-for="item in fiexType" :key="item.id" :value="item.id"
								:label="item.typename">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="0" label="收益中" :value="0">收益中</el-option>
							<el-option key="1" label="已结束" :value="1">已结束</el-option>
							
						</el-select>
					</el-form-item>
					<el-form-item label="结束时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd"
								type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="dinchun()">添加定存</el-button> -->
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="fixed.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="storeName" label="商户名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="typename" label="定存周期" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fixedAmount" label="定存金额" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="rewardRate'" label="收益率" align="center" :show-overflow-tooltip="true">
			
				<template slot-scope="scope">
					<div>{{(scope.row.rewardRate)/100 + '%'}}</div>
					
					
				</template>
			</el-table-column>
				
			<el-table-column prop="status" label="定存状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 1">收益中</div>
					<div v-if="scope.row.status == 0">已结束</div>
					
				</template>
			</el-table-column>
		
			<el-table-column prop="createDate" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			
			<el-table-column prop="successDate" label="结束时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<!-- <el-table-column  label="操作"  fixed="right" align="center" width="140">
				<template slot-scope="scope">
					<div v-if="scope.row.status != 0">不可操作</div>
				</template>
			</el-table-column> -->
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="fixed.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="fixed.total" @size-change="handleSizeChange">
		</el-pagination>
		
		
		
	</div>
</template>

<script>
	export default{
		data(){
			return{
				searchInfo:{},
				loading:false,
				applyDatil:false,
				storeInfo:{},
				time:"",//开始时间
				page: {
					pageNum: 1,
					pageSize: 10
				},
				fixed:{},
				fiexType:[],//定存周期数组
				// typename:'',
			}
		},
		methods:{
			search(){
				this.page.pageNum = 1
				this.fixList()
			},
			empty(){
				this.searchInfo = {}
			},
			// 新增定存弹窗
			dinchun(){
				this.applyDatil = true
			},
			getStoreName(e){
				
			},
			selectStore(){
				this.$api.selectStoreList().then(res=>{
				res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state == 'success'){
						this.selectStoreName = res.data
					}else {
						this.$message.error(res.message);
					}
				})
			},
			half(){
				
			},
			allTixian(){
				
			},
			pageChange(data) {
				this.page.pageNum = data
				this.fixList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.fixList()
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			//获取当前时间，格式YYYY-MM-DD
			getNowTime() {
				var date = new Date();
				//年 getFullYear()：四位数字返回年份
				var year = date.getFullYear(); //getFullYear()代替getYear()
				//月 getMonth()：0 ~ 11
				var month = date.getMonth() + 1;
				//日 getDate()：(1 ~ 31)
				var day = date.getDate();
				// //时 getHours()：(0 ~ 23)
				// var hour = date.getHours();
				// //分 getMinutes()： (0 ~ 59)
				// var minute = date.getMinutes();
				// //秒 getSeconds()：(0 ~ 59)
				// var second = date.getSeconds();
				this.time = year + '-' + this.addZero(month) + '-' + this.addZero(day)
				return this.time;
			},
			addZero(s) {
				return s < 10 ? ('0' + s) : s;
			},
			selectFiextype(){
				this.$api.fixType().then(res=>{
					console.log(res);
					if(res.state == 'success'){
						this.fiexType = res.data
						// this.typename = this.fiexType[0].id
						// this.rewardRate =(this.fiexType[0].rewardRate)/100 + '%'
						// this.fixDay = this.fiexType[0].fixedDays
						// this.fiexId = this.fiexType[0].id
					}
				})
			},
			fixList(){
				this.loading = true
					let data = {
						pageNum: this.page.pageNum,
						pageSize: this.page.pageSize,
						startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
						endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
						...this.searchInfo
					}
					this.$api.fixedList(data).then(res=>{
						console.log(res);
						if(res.state == 'success'){
							this.fixed = res.data
							this.loading = false
						}
					})
				}
		},
		created() {
			this.fixList()
			this.selectFiextype()
			this.getNowTime()
		}
	}
</script>

<style>
</style>